var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsFrameworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15V9H15.5V7H13V1H20V7H17.5V9H20V15H13ZM15 13H18V11H15V13ZM15 5H18V3H15V5ZM4 23V17H6.5V15H4V9H6.5V7H4V1H11V7H8.5V9H11V15H8.5V17H11V23H4ZM6 21H9V19H6V21ZM6 13H9V11H6V13ZM6 5H9V3H6V5Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFrameworks);
export default __webpack_public_path__ + "static/media/icons-frameworks.27a7b846.svg";
export { ForwardRef as ReactComponent };